import axios from 'axios';
import { leadsServiceApi } from '../../../../infra/purchasingApi.service';
import { PURCHASING_API } from '../../../../common/constants/api';
import config from '../../../../config/sbf_config';

export const getAddressLookup = (data) => (
    axios.get(`${config.magento}/address/detail?addressId=${data}`)
        .then((response) => response.data)
        .catch((error) => ({ error }))
);

export const getLeadsPostcode = async (postcode) => {
    const res = await leadsServiceApi({
        method: 'get',
        url: `${PURCHASING_API.LEADS_POSTCODE}?postcode=${postcode}`,
    });

    return res?.data || [];
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/requests/get_address_lookup_request.js